import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { useDispatch, useSelector } from "react-redux";
import { exportFile_NewCustomer } from "../analyzeSlice";

export default function DataExport() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const { duration, selectedCountry, selectedCountryID, newCustomerData } =
    state;

  function exportDataAsFile(isPdf) {
    const postData = {
      isPdf,
      AnalyzeTitle: "Analyze New Customer",
      CountryID: selectedCountryID,
      CountryName: selectedCountry,
      Duration: duration,
      listAnalyseData: newCustomerData,
    };
    dispatch(exportFile_NewCustomer(postData));
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
      }}
    >
      <IconButton onClick={(e) => exportDataAsFile(false)}>
        <GridOnIcon sx={{ color: "green.main" }} />
      </IconButton>
      <IconButton onClick={(e) => exportDataAsFile(true)}>
        <PictureAsPdfIcon sx={{ color: "red.main" }} />
      </IconButton>
    </Box>
  );
}
